module.exports = __webpack_public_path__ + "static/greyboxLogo-7ae0e71a5d40c0af1605638060c104fd.png";